import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconPlus}
 */
const IconPlus = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            viewBox='0 0 20 20'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.08815 10.3428L4.08815 9.656H9.65661L9.65661 4.08753H10.3434L10.3434 9.656H15.9119L15.9119 10.3428L10.3434 10.3428L10.3434 15.9112H9.65661L9.65661 10.3428L4.08815 10.3428Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconPlus;
